export const environment = {
    production: false,
    // urlApi: 'https://api-interna.ratoeiraads.com.br',
    urlApi: 'https://api-dev.ratoeiraads.com.br',
    // urlApi: 'http://localhost:3333',

    urlRatoeiraAdsApi: 'https://raads-ratoeiraads-develop-k547m.ondigitalocean.app',
    // urlRatoeiraAdsApi: 'https://raads-ratoeiraads-egmmu.ondigitalocean.app',
    // urlRatoeiraAdsApi: 'http://localhost:3000',

    urlSite: 'https://app.ratoeiraads.com.br',
    urlBaseIntegracao: 'https://integracao.ratoeiraads.com.br',
    urlBaseIpBlock: 'https://ipblock.ratoeiraads.com.br',
    urlApiFila: 'http://localhost:3000/api',
    urlPostback: 'https://s2s-dev.ratoeiraads.com.br',
    urlRaadsAcesso: 'https://cdn.ratsdigital.com',
    MIXPANEL_TOKEN: 'f3b1a71a2828f890b9798b68537136e0',
    urlMetricas: 'https://api-metricas.ratoeiraads.com.br',
    browserWorkerUrl: 'https://browser-script-scanner-staging.contato-eef.workers.dev',
    // hubAppUrl: 'http://localhost:3002',
    hubAppUrl: 'https://ratoeirahub.com',
    hubAuthEpoch: 2,
    localAccessToken: '',
    upgradeButtonUsesSupportLink: false,
    whatsappModuleEnabled: true,
};
